<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('webhooks')"
      :columns="columns"
      :column_search="true"
      resource_url="/whatsapp/webhook/datatables"
    >
      <template v-slot:buttons>
        <!-- <button
          class="button is-secondary is-rounded"
          @click="$router.push({ path: '/whatsapp/settings' })"
        >
          <span class="icon"><i class="fa fa-cogs"></i></span>
          <span>{{ $t("settings") }}</span>
        </button> -->
        <!-- <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("create") }}</span>
        </button> -->
      </template>
    </generic-table>
    <webhook-modal ref="webhook_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_date_time,
} from "@/utils";
// import WhatsappMessageModal from "../whatsapp_message_modal/Index.vue";
// import LogModal from "../log_modal/Index.vue";
import WebhookModal from "../webhook_modal/Index.vue";
import { truncate } from "lodash";

export default {
  name: "WebhooksDatatable",
  components: { GenericTable, WebhookModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          searchable: false,
          // width: "25%",
          data: (row) => {
            return format_date_time(row.create_date);
          },
        },
        {
          title: v.$t("type"),
          searchable: false,
          // width: "25%",
          data: (row) => {
            let first_change = row.data.entry
              .find((x) => x)
              .changes.find((x) => x);
            return first_change.field;
          },
        },
        {
          title: v.$t("from"),
          searchable: false,
          // width: "25%",
          data: (row) => {
            let first_change = row.data.entry
              .find((x) => x)
              .changes.find((x) => x);
            let field = first_change.field;
            let value = first_change.value;
            // return "";
            if (["messages", "calls"].includes(field)) {
              if (value.contacts)
                return `${value.contacts.find((x) => x).profile.name} (${
                  value.contacts.find((x) => x).wa_id
                })`;
              else if (value.statuses)
                return value.statuses.find((x) => x).recipient_id;
            } else return "X";
          },
        },
        {
          title: v.$t("data"),
          searchable: false,
          // width: "55%",
          data: (row) => {
            // return truncate(JSON.stringify(row), { length: 65 });
            let first_change = row.data.entry
              .find((x) => x)
              .changes.find((x) => x);
            let field = first_change.field;
            let value = first_change.value;
            if (field === "messages") {
              if (value.messages)
                return truncate(
                  first_change.value.messages.find((x) => x).text.body,
                  { length: 65 }
                );
              else if (value.statuses)
                return v.$t(value.statuses.find((x) => x).status);
              else return "XX";
            } else {
              return "";
            }
          },
        },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("details"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.webhook_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete webhook?"),
                    v,
                    () => {
                      del("/whatsapp/webhook", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    // format_date_time,
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
